/**
 * Homepage Data Hook - React Query data fetching
 *
 * Pure data fetching hook that queries the homepage configuration.
 * Use useHomepageState for the composition hook with transformations.
 */
import { useQuery } from '@tanstack/react-query'

import { STATIC_DATA_STALE_TIME, STATIC_DATA_GC_TIME } from '../../constants'
import { homepageApi } from '../../lib'
import { homepageKeys } from '../queryKeys'

import type { HomepageConfigResponse } from '../../types'

/**
 * Raw data fetching hook for homepage configuration
 *
 * Returns the raw React Query result without transformations.
 * For transformed data, use useHomepageState instead.
 */
export const useHomepageData = () => {
  return useQuery<HomepageConfigResponse>({
    queryKey: homepageKeys.config(),
    queryFn: () => homepageApi.getConfig(),
    staleTime: STATIC_DATA_STALE_TIME, // homepage config rarely changes
    gcTime: STATIC_DATA_GC_TIME,
  })
}
